import { render, staticRenderFns } from "./ZachemNuzhnyRaschety.vue?vue&type=template&id=18364b4f&lang=pug&"
import script from "./ZachemNuzhnyRaschety.vue?vue&type=script&lang=js&"
export * from "./ZachemNuzhnyRaschety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports